<a
  id="skip-link"
  class="skip-link"
  href="#main-content"
  (click)="skipToMainContent($event)"
  >Skip to main content</a
>
<ug-alert></ug-alert>
<main>
  @if (isSignedIn()) {
    <header class="container-application" [class]="navbarBgClass">
      <sqep-header
        [helpEntry]="helpEntry()"
        [navbarBgClass]="navbarBgClass"
        [clientLogoAsset]="clientLogoAsset"
        [sidenavOpen]="!collapsed()"
        (toggle)="collapsed.set(!collapsed()); storeMenuState(collapsed())"
      />
    </header>
    <div
      class="page-title"
      [class]="navbarBgClass"
      [class.page-title--viewing]="isViewingOther()"
    >
      @if (router.url.split('?')[0] !== '/home') {
        <span
          [class.page-title-position]="collapsed()"
          [class.page-title-expanded]="!collapsed()"
        >
          <h1>{{ title() }}</h1>
        </span>
      } @else {
        <span
          class="home-header-row"
          [class.page-title-position]="collapsed()"
          [class.page-title-expanded]="!collapsed()"
        >
          @if (isViewingOther()) {
            <div class="viewing-title">
              <div style="display: flex; gap: 8px">
                <h1>Viewing {{ viewingPersonName() }}</h1>

                <mat-icon
                  class="viewing-info-icon"
                  svgIcon="sqep:info"
                  [matTooltip]="viewingPersonTooltip()"
                  matTooltipClass="multiline-tooltip"
                  matTooltipPosition="below"
                  tabindex="0"
                  [attr.aria-label]="viewingPersonTooltip()"
                />
              </div>

              <p class="viewing-subtitle">
                Viewing data as of
                {{ viewingStartedAt() | date: 'HH:mm dd MMMM yyyy' }}
              </p>
            </div>
          } @else {
            <h1>Welcome back, {{ givenName() }}!</h1>
          }
          <sqep-person-selector></sqep-person-selector>
        </span>
      }
    </div>
    <mat-sidenav-container>
      <mat-sidenav
        id="sidebar-nav"
        [autoFocus]="'false'"
        appDrawerAutosizeHack
        opened
        mode="side"
        [fixedInViewport]="'fixed'"
        [fixedBottomGap]="footerOverlap()"
        [style.width]="sidenavWidth()"
        [style.margin-top.px]="67"
      >
        <sqep-custom-sidenav
          [heading]="clientHeading"
          [subTitle]="clientSubTitle"
          [clientLogoAsset2]="clientLogoAsset2"
          [collapsed]="collapsed()"
          [applicationName]="applicationName()"
          [isViewingOther]="isViewingOther()"
          [viewingPersonName]="viewingPersonName()"
          (changeCollapsedState)="collapsed.set(true)"
          (clearViewingAs)="onClearViewingAs()"
        />
      </mat-sidenav>

      <mat-sidenav-content class="content" [style.margin-left]="sidenavWidth()">
        <div class="top-panel" [ngClass]="navbarBgClass"></div>
        <div
          id="main-content"
          tabindex="-1"
          style="padding: 0px 24px 24px 24px; outline: none"
        >
          <router-outlet
            (activate)="onRouterOutletActivate($event)"
          ></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  } @else {
    <router-outlet />
  }
</main>
@if (isSignedIn()) {
  <sqep-footer
    #appFooter
    [isSignedIn]="isSignedIn()"
    [navbarBgClass]="navbarBgClass"
    [guiBuildVersion]="buildNumber()"
    [apiBuildVersion]="esqepBuildVersionNumber()"
    [csodApiBuildVersion]="csodEsqepBuildVersionNumber()"
  />
}
